<div>
  @if (mail) {
    <i class="mail-i mr-1"></i>
  }
  @if (email) {
    <span class="email-i mr-1">@</span>
  }
  @if (print) {
    <i class="print-i"></i>
  }
</div>
